import type { FuelTransactionBodyContent } from '@cobliteam/common-types';
import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';
import { openNewFuelCardTicketToOpenNewFuelCardTicketAPI, toSaveFuelTransactionBody } from './APITransformers';
import type { CardProviderOption, ZendeskTicket } from './Definitions/Types';

export class FuelCardRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public saveFuelTransaction = (body: FuelTransactionBodyContent): Promise<void> => {
    const transactionBody = toSaveFuelTransactionBody(body);
    const requestData: IRequest = {
      endpoint: 'fuel/transactions',
      method: HttpMethod.POST,
      body: JSON.stringify(transactionBody),
    };

    return this.requester.request(requestData).then();
  };

  public requestIntegration = (cardProvider: CardProviderOption, email?: string): Promise<void> => {
    const requestData: IRequest = {
      endpoint: '/fuel/fuel-card-integration',
      method: HttpMethod.POST,
      body: JSON.stringify({ card_provider: cardProvider, email }),
    };

    return this.requester.request(requestData).then();
  };

  public updateManualFeatureFlag = (): Promise<void> => {
    const requestData: IRequest = {
      endpoint: '/fuel/featureFlag',
      method: HttpMethod.PATCH,
      body: JSON.stringify({ flag_name: 'fuel-card-manual' }),
    };

    return this.requester.request(requestData).then();
  };

  public openNewFuelCardTicket = (zendeskTicket: ZendeskTicket): Promise<void> => {
    const requestData: IRequest = {
      endpoint: '/fuel/fuelcard/ticket',
      method: HttpMethod.POST,
      body: JSON.stringify(openNewFuelCardTicketToOpenNewFuelCardTicketAPI(zendeskTicket)),
    };

    return this.requester.request(requestData).then();
  };
}

export default FuelCardRequester;
